const regex = /^\d{5}$/g
export const postalCodeValidator = (value) => {
  return value == null || value === '' || regex.test(value)
}
